// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBjFiS2uOhQZ0DkR6n6a2_h4BolXLAkUiE",
    authDomain: "gtcollective-3abd2.firebaseapp.com",
    projectId: "gtcollective-3abd2",
    storageBucket: "gtcollective-3abd2.appspot.com",
    messagingSenderId: "1092152518912",
    appId: "1:1092152518912:web:86d587261c36e48e6eebe5",
    measurementId: "G-TD1V3S4GSR"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;